module.exports = __webpack_public_path__ + "media/images/sp/maedori_photowedding/banner_maternity-24a27d034a3da61128b7f1621c9844bd.webp";